import React from 'react';
import { useTranslation } from 'react-i18next';

import { Link, useHistory } from 'react-router-dom';

export default function Nav() {
  const { t } = useTranslation();
  const tags = (JSON.parse(sessionStorage.getItem('tags'))!==null)?JSON.parse(sessionStorage.getItem('tags')):[];
  const history = useHistory();

  function carregarTag(hashTag){
    sessionStorage.setItem('hashTag', hashTag);
    history.push(`/timeline/${hashTag}`);
  }
  return (
    <nav>
      <ul>
        <li><Link onClick={()=>carregarTag('')} id="timeline" className="mnu" to="#">{ t('pages.includes.filters.all') }</Link></li>
        <li><Link id="classificados" className="mnu" to="/classificados">{ t('pages.includes.filters.classified') }</Link></li>
        {
          tags.map(tag=>(
            <li>
              <Link to="#" className="mnu" onClick={()=>carregarTag(tag.slug)}>{tag.name}</Link>
            </li>
          ))
        }
      </ul>
    </nav>
  )
}